import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private readonly showSubject = new BehaviorSubject<boolean>(false);
  show$ = this.showSubject.asObservable();

  constructor() {}

  open() {
    this.showSubject.next(true);
  }

  close() {
    this.showSubject.next(false);
  }
}
